<template>
  <div id="app" class="h-100" :class="[skinClasses]">
    <timeout-modal v-if="isIdle" />
    <component :is="layout">
      <router-view />
    </component>

    <!-- <demande-code v-if="$route.matched.some(({ name }) => name != 'auth-login')" /> -->

    <!-- <Popup-Webinar v-if="$route.matched.some(({ name }) => name != 'auth-login')" /> -->


    <scroll-to-top v-if="enableScrollToTop" />
  </div>
</template>

<script>
import DemandeCode from '@/views/modal/DemandeCode.vue'
import PopupWebinar from '@/views/modal/PopupWebinar.vue'

import ScrollToTop from '@core/components/scroll-to-top/ScrollToTop.vue'

// This will be populated in `beforeCreate` hook
import { $themeColors, $themeBreakpoints, $themeConfig } from '@themeConfig'
import { provideToast } from 'vue-toastification/composition'
import TimeoutModal from "./views/modal/TimeoutModal.vue";
import { watch } from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'

import { useWindowSize, useCssVar } from '@vueuse/core'

import store from '@/store'

const LayoutVertical = () => import('@/layouts/vertical/LayoutVertical.vue')
const LayoutHorizontal = () => import('@/layouts/horizontal/LayoutHorizontal.vue')
const LayoutFull = () => import('@/layouts/full/LayoutFull.vue')

export default {
  data(){
    return {
      measurement_id: 'G-Q5GJYDN3BJ'
    }
  },
  components: {

    // Layouts
    LayoutHorizontal,
    LayoutVertical,
    LayoutFull,

    ScrollToTop,
    TimeoutModal,
    DemandeCode,
    PopupWebinar
  },
  watch: {
    '$route' (to, from) {
      if(to.name !== 'auth-login' && to.name !== 'error-404') {
        this.track(to)
      }
    }
  },
  // ! We can move this computed: layout & contentLayoutType once we get to use Vue 3
  // Currently, router.currentRoute is not reactive and doesn't trigger any change
  computed: {
    layout() {
      if (this.$route.meta.layout === 'full') return 'layout-full'
      return `layout-${this.contentLayoutType}`
    },
    contentLayoutType() {
      return this.$store.state.appConfig.layout.type
    },
    isIdle() {
      let host = window.location.host;
      if (host.includes("erp.bubble-in.com") || host.includes("test.bubble-in.com") || host.includes("demo.bubble-in.com")) {
        return this.$store.state.idleVue.isIdle
      }
      return false
    },
  },
  methods: {
    track(data){
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', this.measurement_id, {
        'page_title' : data.name,
        'page_view' : data.name,
        'page_path': data.fullPath,
        'send_page_view': true
      });
    }
  },
  mounted() {
    let host = window.location.host;

    if (host.includes("erp.bubble-in.com") || host.includes("test.bubble-in.com") || host.includes("demo.bubble-in.com")) {
      let recaptchaScript = document.createElement('script')
      recaptchaScript.setAttribute('src', `https://www.googletagmanager.com/gtag/js?id=${this.measurement_id}`)
      document.head.appendChild(recaptchaScript)
    }
  },
  beforeCreate() {
    // Set colors in theme
    const colors = ['primary', 'secondary', 'success', 'info', 'warning', 'danger', 'light', 'dark']

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = colors.length; i < len; i++) {
      $themeColors[colors[i]] = useCssVar(`--${colors[i]}`, document.documentElement).value.trim()
    }

    // Set Theme Breakpoints
    const breakpoints = ['xs', 'sm', 'md', 'lg', 'xl']

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = breakpoints.length; i < len; i++) {
      $themeBreakpoints[breakpoints[i]] = Number(useCssVar(`--breakpoint-${breakpoints[i]}`, document.documentElement).value.slice(0, -2))
    }

    // Set RTL
    const { isRTL } = $themeConfig.layout
    document.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr')
  },
  setup() {
    const { skin, skinClasses } = useAppConfig()
    const { enableScrollToTop } = $themeConfig.layout
    // const isLogedIn = isUserLoggedIn();
    // If skin is dark when initialized => Add class to body
    if (skin.value === 'dark') document.body.classList.add('dark-layout')

    // Provide toast for Composition API usage
    // This for those apps/components which uses composition API
    // Demos will still use Options API for ease
    provideToast({
      hideProgressBar: true,
      closeOnClick: false,
      closeButton: false,
      icon: false,
      timeout: 3000,
      transition: 'Vue-Toastification__fade',
    })

    // Set Window Width in store
    store.commit('app/UPDATE_WINDOW_WIDTH', window.innerWidth)
    const { width: windowWidth } = useWindowSize()
    watch(windowWidth, val => {
      store.commit('app/UPDATE_WINDOW_WIDTH', val)
    })

    return {
      skinClasses,
      enableScrollToTop,
      // isLogedIn
    }
  },
}
</script>
<style>
button {
  text-transform: uppercase !important;
}
.vgt-responsive
{
  min-height: 36vh !important;
}

</style>
